import React, { useEffect, useState, useMemo } from "react";

import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import { fetcher } from "../../client";
import { fetchAllCopyright, fetchCopyright } from "../../actions/copyright";
export function useFetchAllCopyright(params = {}) {
  return useQuery(
    ["copyrights", params],
    () => fetcher(fetchAllCopyright(params)),
    {}
  );
}
export function useFetchCopyright(id) {
  return useQuery(
    ["copyrights", id],
    () => id && fetcher(fetchCopyright(id)),
    {}
  );
}
